module.exports = __webpack_public_path__ + "static/img/3.9bc0933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/3.png
// module id = yulO
// module chunks = 0